import type { TimesheetRecord } from '../hooks/useAccountOwnerData';
import type { OrgBillingRecord } from './orgBillingAnalysisUtils';

/** UC-T8 jsonbyAM rows → org billing shape for shared Timesheet Insights transforms. */
export function mapAccountOwnerTimesheetToOrgBilling(
  records: TimesheetRecord[],
  projectToClient?: Record<
    string,
    { client_id: string; client_name: string }
  >,
): OrgBillingRecord[] {
  return records.map((r) => {
    const pid =
      r.project_id != null && !Number.isNaN(Number(r.project_id))
        ? String(r.project_id)
        : '';
    const mapped = pid ? projectToClient?.[pid] : undefined;
    const clientFromMap = (mapped?.client_name || '').trim();
    const client_name = clientFromMap || undefined;
    const pm = (r.project_manager || '').trim();
    return {
      year: Number(r.year),
      month: Number(r.month) || 1,
      resource_department: (r.resource_department || '').trim() || '—',
      resource_technology: (r.resource_technology || '').trim() || '—',
      resource_grade: (r.resource_grade || '').trim() || '—',
      resource_project: (r.project_name || '').trim() || '—',
      project_id: r.project_id,
      project_category: (r.project_category || '').trim() || '—',
      resource_account_owner: (r.account_manager || '').trim() || '—',
      ...(client_name ? { client_name } : {}),
      ...(pm ? { project_manager: pm } : {}),
      user_id: r.resource_id,
      full_name:
        (r.resource_name || r.resource_username || '').trim() ||
        `User ${r.resource_id}`,
      user_is_active: r.resource_is_active === 1 ? 1 : 0,
      billable_hours: r.billable_hours,
      non_billable_hours: r.non_billable_hours,
      total_hours: r.total_hours,
      total_leaves_days: r.total_leave_days ?? '0',
    };
  });
}
